import styled from 'styled-components';
import { mq, getSpace } from '../../../stylesheets/tools';

const StyledFormCompact = styled.form`
  .form__inner {
    margin: 0 auto;

    ${mq('l')} {
      display: flex;
      align-items: flex-start;
    }

    select {
      color: inherit;
    }
  }

  .checkbox__labelText {
    margin-top: 5px;
  }

  .checkbox__custom-checkbox {
    height: 30px;
    width: 30px;

    svg {
      width: 30px;
    }
  }

  .infoText {
    padding-top: ${getSpace('xxxs')};
    p {
      font-size: 12px;
      line-height: 1.5;
    }
  }

  .form__field-container {
    .input__wrapper {
      .input__label {
        margin: 0;
        width: 120px;
      }
      .input__inner {
        padding: 10px 4px 6px 4px;

        input {
          font-size: 14px;
          padding: 1.4rem 0.65rem 0.65rem 0.65rem;
        }
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 80px white inset !important;
        }
      }
    }
  }

  .form__inner .form__field-container .input__wrapper {
    align-items: start;

    input:focus {
      background: none;
    }
  }

  ${mq(767, 'max')} {
    .input__wrapper {
      display: flex;
      flex-direction: column;

      .input__label {
        width: 100%;
        margin: 0;
      }
      .input__inner {
        width: 100%;
      }
    }
  }

  ${mq('m')} {
    .form__inner .form__field-container .input__wrapper {
      align-items: center;
    }
    .form__inner .form__field-container .input__wrapper {
      background: black;
    }
  }

  .form__cell {
    width: 100%;
    margin-bottom: ${getSpace('xs')};

    ${mq('m')} {
      flex-grow: 1;
      margin-bottom: ${getSpace('s')};

      &--half {
        flex-grow: 0;
        width: 50%;
      }
    }
  }

  .form__submit {
    max-width: 340px;

    ${mq('l')} {
      padding-left: 25px;
    }
  }

  .form__submit-button {
    display: flex;
    justify-content: flex-end;

    button {
      width: 100%;

      ${mq('l')} {
        max-width: 220px;
        padding-top: 24px;
        font-size: 16px;
        margin: 0;
      }
    }
  }

  .form__recaptcha-wrapper {
    display: flex;
    padding-bottom: ${getSpace('xs')};
  }

  .form__recaptcha-error {
    position: absolute;
    text-transform: uppercase;
    top: 100%;
    left: 0;
    font-size: 12px;
    color: red;
    padding: 10px 15px;
    visibility: hidden;
    opacity: 0;
  }

  .form__recaptcha {
    min-height: 78px;
    position: relative;
    border: 2px solid transparent;
    border-radius: 5px;

    &.has-error {
      border-color: red;

      .form__recaptcha-error {
        visibility: visible;
        opacity: 1;
      }
    }
  }
`;

export default StyledFormCompact;
